// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1___a32090fe4b8d3d89cde","cls2":"SuggestedUserCard-cls2___45371e13776a225246a SuggestedUserCard-cls1___a32090fe4b8d3d89cde"};